import CompareArrowsIcon from 'material-ui/svg-icons/action/compare-arrows';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import * as userActions from 'actions/userActions';
import * as workOrderActions from 'actions/workOrderActions';
import Footer from 'containers/Footer';
import Loading from 'components/layout/Loading';
import { red500, green500 } from 'material-ui/styles/colors';

export class WorkOrderTransferPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            workOrderNumber: '',
            toTechId: '',
        }

        this.onInputValueChange = this
            .onInputValueChange
            .bind(this);

        this.onTransferWorkOrder = this.onTransferWorkOrder.bind(this);
    }

    componentDidMount() {
        const { workOrderActions } = this.props;
        workOrderActions.clearWorkOrderTransferState();
    }

    onTransferWorkOrder(event) {
        const { workOrderNumber, toTechId } = this.state;
        const { workOrderActions } = this.props;
        event.preventDefault();

        workOrderActions.transferWorkOrderStarted(toTechId, workOrderNumber);
    }

    onInputValueChange(value, key) {
        this.setState({ [key]: value });
    }

    getTransferMessage() {
        const { workOrder } = this.props;
        const success = workOrder.get('workOrderTransferSuccess');
        const error = workOrder.get('workOrderTransferError');

        return (
            <div
                style={{
                    minHeight: '150px',
                    paddingTop: '10px',
                    textAlign: 'center'
                }}>
                {success ? <h5 style={{ color: green500 }}>Work Order Transfered Successfully</h5> :
                    error ? <h5 style={{ color: red500 }}>{error}</h5> : null}
            </div>
        );
    }

    render() {
        const { workOrderNumber, toTechId } = this.state;
        const { user, workOrder } = this.props;
        const loading = workOrder.get('workOrderTransferSubmitting');

        return (
            <div>
                <h5 style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '2em', justifyContent: 'center' }}>
                    <CompareArrowsIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                    Work Order Transfer
                </h5>
                <div>
                    <form className="searchForm" onSubmit={this.onTransferWorkOrder}>
                        <div className="row">
                            Order Number:<br />
                            <TextField
                                className="wow-fst-input-container"
                                value={workOrderNumber}
                                hintText="Enter Work Order Number"
                                fullWidth={true}
                                disabled={!user.get('isFieldAdmin')}
                                onChange={(e) => this.onInputValueChange(e.target.value, 'workOrderNumber')}
                            />
                        </div>
                        <div className="row">
                            To Tech Id:<br />
                            <TextField
                                className="wow-fst-input-container"
                                value={toTechId}
                                hintText="Enter Tech Id"
                                disabled={!user.get('isFieldAdmin')}
                                fullWidth={true}
                                onChange={(e) => this.onInputValueChange(e.target.value, 'toTechId')}
                            />
                        </div>
                        <div className="row">
                            <RaisedButton
                                disabled={!workOrderNumber || !toTechId || !user.get('isFieldAdmin')}
                                label="Transfer"
                                type="submit"
                                primary={true}
                                style={{
                                    margin: 12
                                }} />
                        </div>
                    </form>
                </div>
                {loading && <Loading message="Transfering..." isLoading={loading} />}
                {this.getTransferMessage()}
                <Footer />
            </div>
        );
    }
}

WorkOrderTransferPage.propTypes = {
    user: PropTypes.object,
    userActions: PropTypes.object,
    workOrderActions: PropTypes.object,
    workOrder: PropTypes.object
};

function mapStateToProps(state) {
    return {
        user: state.get('user'),
        workOrder: state.get('workOrder')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        workOrderActions: bindActionCreators(workOrderActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        push: bindActionCreators(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderTransferPage);


// WEBPACK FOOTER //
// ./src/containers/pages/WorkOrderTransferPage.js